import { render } from "./dictionary.html?vue&type=template&id=7cd8120e&scoped=true&ts=true"
import script from "./dictionary.ts?vue&type=script&lang=ts"
export * from "./dictionary.ts?vue&type=script&lang=ts"

import "./dictionary.scss?vue&type=style&index=0&id=7cd8120e&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cd8120e"]])

export default __exports__